import { PageLoadingFullscreen } from '../../components/general/PageLoadingFullscreen';

const createRedirectUri = (urlHashPart: string): string => {
  const hashValues = decodeURIComponent(urlHashPart).split('&');
  const state = hashValues.find((value) => value.startsWith('state='));

  const states = state?.split('|');
  if (states?.length === 2) {
    const redirectUri = states[1];
    return `${redirectUri}${urlHashPart}`;
  } else {
    return `/${urlHashPart}`;
  }
};

const isRedirectAllowed = (uri: string): boolean => {
  const allowedPatterns = [
    /^\//u,
    /^http:\/\/localhost:4444/u,

    // Viva Planung
    /^https:\/\/va\.vamos\.ban\.haufe-akademie\.de/u,
    /^https:\/\/va\.vamos\.ban\.akadev\.de/u,
    /^https:\/\/dev-.{1,29}\.va\.vamos\.ban\.akadev\.de/u,

    // Viva SAP-Adapter
    /^https:\/\/viva\.vamos\.ban\.haufe-akademie\.de/u,
    /^https:\/\/viva\.vamos\.ban\.akadev\.de/u,
    /^https:\/\/dev-.{1,29}\.viva\.vamos\.ban\.akadev\.de/u,
  ];

  return allowedPatterns.some((pattern) => pattern.test(uri));
};

export const AuthRedirectPage = () => {
  const redirectUri = createRedirectUri(window.location.hash);

  if (isRedirectAllowed(redirectUri)) {
    // eslint-disable-next-line @eslint-react/purity -- added during migration to ban-pdk. please solve issue or explain disable-reason here
    window.location.replace(redirectUri);
  } else {
    throw new Error('redirect blocked', { cause: `redurect uri: ${redirectUri}` });
  }

  return <PageLoadingFullscreen msg="Weiterleitung..." />;
};
